import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { TickIcon, TickSVG, TickSVGBlack } from '../Icons';
import { truncateField } from '@src/helpers/Helpers';
import { IsMobileWidth } from '../MediaQueryUtils';
import { RESTAURANT } from '@src/Constants';

interface Step {
	number: number;
	changes: string[];
	title: { name: string; date: string; time: string };
	active?: boolean;
	user_type: string;
}

interface CustomStepperProps {
	steps: Step[];
	style?: React.CSSProperties;
}

const StepContainer = styled.div<{ step: Step }>`
	position: relative;
	height: ${(props) => props.step?.changes?.length * 30 + 72}px;
	color: grey;
	> div:first-child {
		position: static;
		height: 0;
	}
	#line {
		margin-left: 1.5em;
		padding-left: 1em;
		position: relative;
		&::before {
			content: '';
			position: absolute;
			left: -17.5px; /* Adjust this value to control the position of the line */
			width: 2px;
			top: -9px;
			height: ${(props) => props.step?.changes?.length * 30 + 58}px;
			background-color: #f1f1f1;
		}
	}
	&.step-active {
		color: #4285f4;
	}
	&.step-active .circle {
		background-color: #0069b4;
	}
`;

const ChangesList = styled.ul`
	color: #7d7d7d;
	font-size: 14px;
	font-weight: 600;
	font-size: 0.8em;
	list-style-type: disc;
	padding-left: 1em;
	margin-top: 0.5em;
`;

const ChangeItem = styled.li`
	margin-bottom: 0.25em;
`;

const StepperTitle = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	letter-spacing: 0.28px;
	#type {
		color: var(--Gray-g-600, #7d7d7d);
		font-size: 12px;
		font-weight: 700;
		margin-left: 3.1em;
		position: absolute;
		bottom: 26px;
	}
	#log {
		display: flex;
		align-items: center;
		gap: 20px;
		margin-left: 2.7em;
		margin-top: 3px;
		color: #333;
		font-size: 14px;
		font-weight: 700;
		#date {
			font-weight: 700;
		}
		#time {
			color: #acacac;
			font-size: 12px;
			font-weight: 600;
		}
	}
`;

const CustomStepper: React.FC<CustomStepperProps> = ({ steps, style }) => {
	const isMobileWidth = IsMobileWidth();
	return (
		<div style={style}>
			{steps.map((step, index) => (
				<StepContainer step={step} key={index}>
					<div style={{ zIndex: 40 }}>
						{step?.user_type?.toLowerCase() === RESTAURANT ? <TickSVG /> : <TickSVGBlack />}
					</div>
					<StepperTitle>
						<div id="type">{`${
							step?.user_type?.toLowerCase() === RESTAURANT ? 'Dealer' : 'Supplier'
						}`}</div>
						<div id="log">
							<div id="name">{truncateField(step?.title?.name, isMobileWidth ? 10 : 30)}</div>
							<div id="date">{step?.title?.date}</div>
							<div id="time">{step?.title?.time}</div>
						</div>
					</StepperTitle>
					<div id="line">
						<ChangesList>
							{step?.changes?.map((change, i) => (
								<ChangeItem key={i} dangerouslySetInnerHTML={{ __html: change }} />
							))}
						</ChangesList>
					</div>
				</StepContainer>
			))}
		</div>
	);
};

export default CustomStepper;
